import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import smallurgent from "../../practices_images/small-urgent.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const SmallUrgent = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    <div className="cap-container">
    <h1>Small and Mid-Sized Urgent Cares</h1>

    <div className="cap-section">
        {/* Text Content */}
        <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting high volume care with operational control</h3>
            <p>
              Urgent care centers provide immediate access to care for non life threatening conditions in fast paced, walk in environments. Patient flow is unpredictable, visit volumes fluctuate daily, and operational efficiency is critical to both patient experience and financial performance.
            </p>
            <p>
              We partner with small and mid sized urgent care centers to help them operate with clarity, speed, and consistency.
            </p>

            <h3>The Operating Environment</h3>
            <p>
              Urgent care centers rely on efficient intake, accurate documentation, and reliable billing processes to sustain performance. Because care is delivered quickly and often without prior patient history, even minor operational gaps can lead to claim denials, delayed reimbursement, or compliance risk.
            </p>
            <p>
              Technology limitations and staffing pressure can further strain day to day operations if systems are not aligned.
            </p>

            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help urgent care centers strengthen the operational and financial processes that support high throughput care delivery.
              </p>
              <p>
                Our work focuses on reinforcing documentation and coding accuracy, supporting reliable billing and reimbursement processes, improving financial visibility, and strengthening technology and security practices that protect patient data and support compliance.
              </p>
              <p>
                Our approach reflects the speed and intensity of urgent care environments.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Enabling Speed and Stability">
              <p>
                Our goal is to help centers operate efficiently without sacrificing control.
              </p>
              <p>
                By reducing administrative friction and improving revenue predictability, we support faster reimbursement, fewer denials, and smoother day to day operations. This allows care teams to focus on patients while leadership maintains oversight of performance and risk.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Looking Ahead">
              <p>
                As demand for on demand care continues to grow, urgent care centers must operate with discipline and adaptability.
              </p>
              <p>
                We work with organizations to build the structure, systems, and clarity required to sustain growth while maintaining quality and compliance.
              </p>
              <p>
                Let’s begin a conversation about how your urgent care center can move forward with confidence and purpose.
              </p>
            </CollapsibleSection>
        </div>

        {/* Image Section */}
        <div className="image-container">
        {<img src={smallurgent} alt="Small and Mid-Sized Urgent Cares" />}
        </div>
    </div>
    </div>

  </motion.div>
  );
};

export default SmallUrgent;
